import { render, staticRenderFns } from "./HdsSelect.vue?vue&type=template&id=37125773&scoped=true&"
import script from "./HdsSelect.vue?vue&type=script&lang=ts&"
export * from "./HdsSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37125773",
  null
  
)

export default component.exports